import React from 'react';

interface WiziQuizActionButtonsProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  hasAnswer: boolean;
  isMarkedForReview: boolean;
  onSaveAndNext: () => void;
  onClear: () => void;
  onSaveAndMarkForReview: () => void;
  onMarkForReviewAndNext: () => void;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  disabled?: boolean;
}

const WiziQuizActionButtons: React.FC<WiziQuizActionButtonsProps> = ({
  currentQuestionIndex,
  totalQuestions,
  hasAnswer,
  isMarkedForReview,
  onSaveAndNext,
  onClear,
  onSaveAndMarkForReview,
  onMarkForReviewAndNext,
  onPrevious,
  onNext,
  onSubmit,
  disabled = false,
}) => {
  const isFirstQuestion = currentQuestionIndex === 0;
  const isLastQuestion = currentQuestionIndex === totalQuestions - 1;

  return (
    <div className="bg-light border-top p-3">
      <div className="row g-2">
        {/* Top Row - Main Action Buttons */}
        <div className="col-12">
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            {/* Save & Next */}
            <button
              className="btn btn-success"
              onClick={onSaveAndNext}
              disabled={disabled || !hasAnswer}
              title="Save answer and move to next question"
            >
              <i className="fas fa-save me-2"></i>
              SAVE & NEXT
            </button>

            {/* Clear */}
            <button
              className="btn btn-secondary"
              onClick={onClear}
              disabled={disabled || !hasAnswer}
              title="Clear your response"
            >
              <i className="fas fa-eraser me-2"></i>
              CLEAR
            </button>

            {/* Save & Mark for Review */}
            <button
              className="btn btn-warning"
              onClick={onSaveAndMarkForReview}
              disabled={disabled || !hasAnswer}
              title="Save answer and mark for review"
            >
              <i className="fas fa-bookmark me-2"></i>
              SAVE & MARK FOR REVIEW
            </button>

            {/* Mark for Review & Next */}
            <button
              className="btn btn-outline-warning"
              onClick={onMarkForReviewAndNext}
              disabled={disabled}
              title="Mark for review and move to next"
            >
              <i className="fas fa-flag me-2"></i>
              MARK FOR REVIEW & NEXT
            </button>
          </div>
        </div>

        {/* Bottom Row - Navigation & Submit */}
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            {/* Previous Button */}
            <button
              className="btn btn-outline-primary"
              onClick={onPrevious}
              disabled={disabled || isFirstQuestion}
            >
              <i className="fas fa-chevron-left me-2"></i> BACK
            </button>

            {/* Submit Button (center) */}
            <button
              className="btn btn-danger btn-lg"
              onClick={onSubmit}
              disabled={disabled}
              title="Submit quiz for evaluation"
            >
              <i className="fas fa-check-circle me-2"></i>
              SUBMIT
            </button>

            {/* Next Button */}
            <button
              className="btn btn-outline-primary"
              onClick={onNext}
              disabled={disabled || isLastQuestion}
            >
              NEXT <i className="fas fa-chevron-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WiziQuizActionButtons;
